import { cn } from '@/utils/shadcn';
import ReactMarkdown from 'react-markdown';

const markdownStyles =
  'prose prose-sm max-w-none prose-p:leading-normal prose-p:my-1 prose-headings:mb-2 prose-headings:mt-4 first:prose-headings:mt-1 prose-li:my-1 prose-ul:my-1 prose-ol:my-1 prose-pre:my-1 prose-blockquote:my-1 prose-pre:bg-muted/50 prose-pre:p-2 prose-pre:rounded-md';

interface MarkdownProps extends React.ComponentProps<typeof ReactMarkdown> {
  inverted?: boolean;
  className?: string;
}

export const Markdown = ({
  inverted = false,
  className,
  children,
  ...props
}: MarkdownProps) => {
  return (
    <ReactMarkdown
      className={cn(markdownStyles, inverted && 'prose-invert', className)}
      {...props}>
      {children}
    </ReactMarkdown>
  );
};
